var map = {
	"./Backrooms.png": 11149,
	"./BambooForest.png": 99739,
	"./BrickMaze.png": 35952,
	"./Carnival.png": 73014,
	"./Castle.png": 48068,
	"./Cornfield.png": 45368,
	"./Crypts.png": 98051,
	"./DeadForest.png": 64169,
	"./FogCity.png": 1167,
	"./Forest.png": 27711,
	"./Jungle.png": 39395,
	"./KeptHedges.png": 6538,
	"./Manor.png": 47997,
	"./Mines.png": 11026,
	"./Sewers.png": 17885,
	"./SnowyHedges.png": 81410,
	"./Swamp.png": 35778,
	"./Trenches.png": 74786,
	"./UnkeptHedges.png": 34847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10002;